import { createFileRoute } from '@tanstack/react-router';
import { LessonOverview } from '@/features/Lesson/LessonOverview';
import { useTopicDetail } from '@/lib/hooks/useLms';

export const Route = createFileRoute('/_student/courses/$batchId/topics/$topicId/')({
  component: OverviewRoute,
});

function OverviewRoute() {
  const { batchId, topicId } = Route.useParams();
  const { data: topic } = useTopicDetail(topicId);
  if (!topic) return null;

  const now = Date.now();
  const upcomingSession = topic.sessions.find((s) => {
    if (s.recording_url || !s.scheduled_at) return false;
    const start = new Date(s.scheduled_at).getTime();
    if (Number.isNaN(start)) return false;
    return start + (s.duration_mins ?? 60) * 60_000 >= now;
  }) ?? null;

  return (
    <LessonOverview
      description={topic.description} upcomingSession={upcomingSession}
      estimatedHours={topic.estimated_hours} topicType={topic.topic_type}
      sessionCount={topic.sessions.length} resourceCount={topic.resources.length} assessmentCount={topic.assessments.length}
      visualization={topic.visualization} batchId={batchId} topicId={topicId}
      pattern={topic.pattern} moduleTitle={topic.module_title}
    />
  );
}
